/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TimeCategoryDetails { 
    name?: string;
    percentage?: number;
    duration_in_seconds?: number;
    previous_duration_in_seconds?: number;
    previous_percentage?: number;
}

